import { render, staticRenderFns } from "./ClientProducts.vue?vue&type=template&id=cee598c8&"
import script from "./ClientProducts.vue?vue&type=script&lang=js&"
export * from "./ClientProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports